---
title: 🏕️ ARRL Field Day 2025 📡
date: 2025-06-27
endDate: 2025-06-29
location: Redtail Campground, McCroskey State Park, 3374+4H Potlatch, ID 83855
coordinates: 47.063004314963926, -116.94360141387877
description: Join us at McCroskey State Park Redtail Campground for ARRL Field Day 2025! Come early Friday and stay through Sunday as we set up, operate, and demo emergency communications. 🔧🎉
published: true
---

# 🏕️ ARRL Field Day 2025 📡

Join the Do Something Amateur Radio Club for the most popular on-the-air event in North America!  

---

## 📅 Event Schedule

- **Arrival & Camp Setup:**  
  - Friday, June 27, 2025 @ 12:00 PM PDT  
- **Official Field Day Operation:**  
  - Saturday, June 28, 2025 @ 11:00 AM PDT – Sunday, June 29, 2025 @ 11:00 AM PDT  
- **Breakdown & Departure:**  
  - Sunday, June 29, 2025 @ ~12:00 PM PDT  

---

## 📍 Location & Map

**Redtail Campground**  
McCroskey State Park  
3374+4H Potlatch, ID 83855  
[Park Info & Rules](https://parksandrecreation.idaho.gov/parks/mccroskey/)  
[Google Maps](https://maps.app.goo.gl/yKCaPfuG6GtTfw8S8)  

<div class="mb-8">
  <iframe
    title="Map of Redtail Campground, McCroskey State Park"
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2717.8488954213285!2d-116.9484562570592!3d47.06281439697192!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549fe903be0cb8a5%3A0xa8a0da82dfd8801f!2sRedtail%20Campground!5e0!3m2!1sen!2sus!4v1746743946583!5m2!1sen!2sus"
    width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"
    referrerpolicy="no-referrer-when-downgrade">
  </iframe>
</div>

---

## 🎯 About ARRL Field Day

ARRL Field Day is ham radio’s annual “open house” and emergency communications drill. On the fourth full weekend in June, more than 31,000 operators set up temporary stations to demonstrate radio’s resilience and skill in less-than-optimal conditions.

**Field Day Goals:**  
- Test emergency communication readiness
- Practice setting up and operating portable stations
- Engage the public & showcase ham radio
- Build teamwork & technical skills

---

## 🧰 What to Bring

- Your own radio gear (handhelds, mobile rigs, batteries)(Club will also provide HF radios)
- Headset or hand mic (if available)
- Notebook & logging pencils
- Comfortable camp chair & shade shelter
- Water, snacks, and personal items
- Tent/overnight gear (campground is primitive but campers vans/trucks/trailers are welcome)

---

## 🎁 Club Will Provide

- HF Radios (But feel free to bring your own)
- Antennas, masts, and coax cables (But feel free to bring your own)
- Generators & power distribution
- Logging computers & software
- Digital modems
- Snacks & refreshments

---

## 🔗 Resources & Links

- [ARRL Field Day Overview](https://www.arrl.org/field-day)
- [2025 Field Day Rules & Packet](https://www.arrl.org/field-day-rules)

---

## 📬 RSVP & Contact

Help us coordinate antennas and food—please **RSVP** via our [contact page](/contact) or join our Discord: <https://discord.gg/432vsVAuwZ> 🎉

Questions? Call or text **Austin (KF7SIW)** on 146.820 MHz.